var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1248 3.67547C17.1748 2.79047 18.8698 2.79047 19.8898 3.67547L22.2598 5.70047C22.7098 6.07547 23.5648 6.39047 24.1648 6.39047H26.7148C28.3048 6.39047 29.6098 7.69547 29.6098 9.28547V11.8355C29.6098 12.4355 29.9248 13.2755 30.2998 13.7255L32.3248 16.0955C33.2098 17.1455 33.2098 18.8405 32.3248 19.8605L30.2998 22.2305C29.9248 22.6805 29.6098 23.5205 29.6098 24.1205V26.6705C29.6098 28.2605 28.3048 29.5655 26.7148 29.5655H24.1648C23.5648 29.5655 22.7248 29.8805 22.2748 30.2555L19.9048 32.2805C18.8548 33.1655 17.1598 33.1655 16.1398 32.2805L13.7698 30.2555C13.3198 29.8805 12.4648 29.5655 11.8798 29.5655H9.25482C7.66482 29.5655 6.35982 28.2605 6.35982 26.6705V24.1055C6.35982 23.5205 6.05982 22.6655 5.68482 22.2305L3.65982 19.8455C2.78982 18.8105 2.78982 17.1305 3.65982 16.0955L5.68482 13.7105C6.05982 13.2605 6.35982 12.4205 6.35982 11.8355V9.30047C6.35982 7.71047 7.66482 6.40547 9.25482 6.40547H11.8498C12.4498 6.40547 13.2898 6.09047 13.7398 5.71547L16.1248 3.67547Z",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.1953V19.4403",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9917 24H18.0052",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.26ce3cf458be00d6e92bfd89a39a551f.svg";
export { ForwardRef as ReactComponent };